<script setup>
import { getRequest, postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";
import JobTypeKeywordSelector from "@/views/jobType/jobTypeKeyword/modules/JobTypeKeywordSelector.vue";
import JobTypePreferenceSelector from "@/views/jobType/jobTypePreference/modules/JobTypePreferenceSelector.vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);

const formModel = ref({});
const formRef = ref();
const treeList = ref([]);
const rules = reactive({
  parentId: [
    {
      required: true,
      message: "请选择上级菜单",
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
  ],
  sort: [
    {
      required: false,
      message: "请输入排序",
      trigger: "blur",
    },
  ],
});
const preferenceOptions = ref([]);
const keywordOptions = ref([]);

const handleAdd = (record) => {
  if (record.parentId) {
    if (record.parentType === "BIG_CATEGORY") {
      record.type = "SMALL_CATEGORY";
    } else if (record.parentType === "SMALL_CATEGORY") {
      record.type = "JOB";
    }
  } else {
    record.type = "BIG_CATEGORY";
  }
  handleEdit(record);
};

const handleEdit = (record) => {
  formModel.value = Object.assign({}, { ...record });
  console.info("formModel.value", formModel.value);
  if (formModel.value.preferenceIds) {
    formModel.value.preferenceIds = formModel.value.preferenceIds.split(",");
  } else {
    formModel.value.preferenceIds = [];
  }

  if (formModel.value.keywordIds) {
    formModel.value.keywordIds = formModel.value.keywordIds.split(",");
  } else {
    formModel.value.keywordIds = [];
  }

  loadData();
  open.value = true;
  loadPreferenceOptions();
  loadKeywordOptions();
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
};

const handleConfirm = () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = Object.assign({}, unref(formModel));
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    if (
      unrefFormModel.preferenceIds &&
      unrefFormModel.preferenceIds.length > 0
    ) {
      unrefFormModel.preferenceIds = unrefFormModel.preferenceIds.toString();
    } else {
      unrefFormModel.preferenceIds = "";
    }

    if (unrefFormModel.keywordIds && unrefFormModel.keywordIds.length > 0) {
      unrefFormModel.keywordIds = unrefFormModel.keywordIds.toString();
    } else {
      unrefFormModel.keywordIds = "";
    }
    request("/jobType", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

const loadData = () => {
  getRequest("/jobType").then((response) => {
    if (response.success) {
      treeList.value = response.data.map((bigCategory) => {
        const children = bigCategory.children.map((smallCategory) => {
          const { children, ...smallCategoryData } = smallCategory;
          return {
            ...smallCategoryData,
          };
        });
        return {
          ...bigCategory,
          children,
        };
      });

      console.info("treeList.value", treeList.value);
    }
  });
};

const loadPreferenceOptions = () => {
  getRequest("/jobTypePreference/options").then((response) => {
    if (response.success) {
      preferenceOptions.value = response.data;
      // rawPreferenceOptions.value = response.data;
    }
  });
};

const loadKeywordOptions = () => {
  getRequest("/jobTypeKeyword/options").then((response) => {
    if (response.success) {
      keywordOptions.value = response.data;
      // rawKeywordOptions.value = response.data;
    }
  });
};

const typeChange = () => {
  rules.parentId[0].required = ["SMALL_CATEGORY", "JOB"].includes(
    formModel.value.type,
  );
};

const filterOption = (inputValue, treeNode) => {
  return (
    treeNode.label.includes(inputValue) ||
    treeNode.category.includes(inputValue)
  );
};

const keywordSelector = ref();
const preferenceSelector = ref();

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="名称" name="name">
        <a-input v-model:value="formModel.name" placeholder="请输入名称" />
      </a-form-item>
      <a-form-item label="类型" name="type">
        <a-radio-group
          v-model:value="formModel.type"
          button-style="solid"
          :disabled="true"
          @change="typeChange"
        >
          <a-radio-button value="BIG_CATEGORY">大类</a-radio-button>
          <a-radio-button value="SMALL_CATEGORY">小类</a-radio-button>
          <a-radio-button value="JOB">工种</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <template
        v-if="formModel.type === 'SMALL_CATEGORY' || formModel.type === 'JOB'"
      >
        <a-form-item label="上级菜单" name="parentId">
          <a-tree-select
            :treeData="treeList"
            v-model:value="formModel.parentId"
            :fieldNames="{
              children: 'children',
              label: 'name',
              value: 'id',
            }"
            :disabled="true"
            placeholder="请选择上级菜单"
          ></a-tree-select>
        </a-form-item>
      </template>
      <a-form-item label="排序" name="sort">
        <a-input-number
          v-model:value="formModel.sort"
          placeholder="请输入排序"
          style="width: 100%"
        />
      </a-form-item>

      <a-form-item label="职位偏好" name="preferenceIds">
        <a-tree-select
          v-model:value="formModel.preferenceIds"
          :tree-data="preferenceOptions"
          :filter-tree-node="filterOption"
          mode="multiple"
          :multiple="true"
          placeholder="请输入职位偏好，支持多选"
          :height="233"
          :allow-clear="true"
          @click="preferenceSelector.handleShow(formModel.preferenceIds)"
        >
          <template #title="{ label, category }">
            <a-tag color="blue">
              {{ category }}
            </a-tag>
            {{ label }}
          </template>
        </a-tree-select>
      </a-form-item>
      <a-form-item label="职位关键字" name="keywordIds">
        <a-tree-select
          v-model:value="formModel.keywordIds"
          :tree-data="keywordOptions"
          :filter-tree-node="filterOption"
          mode="multiple"
          :multiple="true"
          placeholder="请输入职位关键字，支持多选"
          :height="233"
          :allow-clear="true"
          @click="keywordSelector.handleShow(formModel.keywordIds)"
        >
          <template #title="{ label, category }">
            <a-tag color="blue">
              {{ category }}
            </a-tag>
            {{ label }}
          </template>
        </a-tree-select>
      </a-form-item>
    </a-form>
    <job-type-keyword-selector
      ref="keywordSelector"
      @ok="(selectedIds) => (formModel.keywordIds = selectedIds)"
    />
    <job-type-preference-selector
      ref="preferenceSelector"
      @ok="(selectedIds) => (formModel.preferenceIds = selectedIds)"
    />
  </a-modal>
</template>

<style scoped lang="scss"></style>
